import { COMMON_DATE_FORMAT } from "constants/app.constant";
import { Notification, Tag, toast } from "components/ui";
import { HiOutlinePlusCircle } from "react-icons/hi";
import { TABLE_ACTION_KEYS } from "constants/app.constant";
import { getState } from "store";
import moment from "moment";
import { APP_API } from "constants/api.constant";
import appConfig from "configs/app.config";
import { FaCheckCircle, FaTimesCircle } from "react-icons/fa";
import { ROLES } from "constants/roles.constant";
import { postApi } from "services/CommonService";

const USER_STATUS = [
  { id: 0, name: "inactive" },
  { id: 1, name: "active" },
  { id: 2, name: "deleted" },
];

export const MASTER_DATA_TYPES = [
  { label: "Plants", value: 1 },
  { label: "StorageLocations", value: 2 },
  { label: "ProductsInventory", value: 3 },
  { label: "customers", value: 4 },
  { label: "Inventory", value: 5 },
];

export const BLOCKED_DATA_TYPES = [
  { label: "Plants", value: 1 },
  { label: "StorageLocations", value: 2 },
  { label: "ProductsInventory", value: 3 },
  { label: "customers", value: 4 },
  { label: "Users", value: 5 },
  { label: "Inventory", value: 6 },
];

export const SECONDARY_SALES_TYPES = {
  SAP_SALES_INVOICE: 1,
  SAP_SALES_INVOICE_ETA: 2,
};

export const USERS_TYPES = [
  { label: "SUPER ADMIN", value: 1 },
  { label: "EXECUTIVE BOARD", value: 2 },
  { label: "SECOND LEVEL MANAGER", value: 3 },
  { label: "ZONAL MANAGER", value: 4 },
  { label: "FIRST LEVEL MANAGER", value: 5 },
  { label: "ACCOUNTS TEAM", value: 6 },
  { label: "SALES MEMBER", value: 7 },
];

export const EXPORT_DATA_TYPES = [
  { label: "Plant", value: 1 },
  { label: "storage locations", value: 2 },
  { label: "material", value: 3 },
  { label: "customers", value: 4 },
  { label: "Sales orders", value: 5 },
  { label: "Sales invoices", value: 6 },
  { label: "Sales Based on ETA", value: 7 },
  { label: "Secondary Sales", value: 8 },
  { label: "Sales with Picklist", value: 9 },
];

// const date = new Date();

// export const firstDay = new Date(
//   date.getFullYear(),
//   date.getMonth(),
//   date.getDate() - date.getDay()
// );

// export const lastDay = new Date(
//   date.getFullYear(),
//   date.getMonth(),
//   date.getDate() + (6 - date.getDay())
// );

export const firstDay = new Date(moment().subtract(1, "month").startOf("month").format());
export const lastDay = new Date(moment().endOf("month").format());

export const generateDeviceId = () => {
  let deviceId = localStorage.getItem("device_id");
  if (!deviceId) {
    deviceId = `userID_${Date.now()}_${Math.floor(Math.random() * 1000)}`;
  }
  localStorage.setItem("device_id", deviceId);
  return deviceId;
};

export const arrayToString = (fieldName) => {
  return (
    <>
      {[fieldName]?.length > 0
        ? [fieldName].map((str, i, arr) => {
            return (
              <div className="capitalize">{`${str} ${
                i !== [fieldName]?.length - 1 ? "," : ""
              }`}</div>
            );
          })
        : "-"}
    </>
  );
};

export const ValidateData = (data) => {
  if (data === "null" || !data) {
    return false;
  }
  return true;
};

export const getFormatedDate = (date, formatter = COMMON_DATE_FORMAT) => {
  const dateObject = moment.utc(date).local();
  const formattedDate = dateObject.format(formatter);
  return formattedDate;
};

export const getTagLabelFromObject = (value, object) => {
  const dataObj = object.find((obj) => obj?.value === value);
  return (
    <Tag
      className={`bg-${dataObj?.color}-100 text-${dataObj?.color}-600 dark:bg-${dataObj?.color}-500/20 dark:text-${dataObj?.color}-100 border-0 rounded`}
    >
      {dataObj.label}
    </Tag>
  );
};

export const chnageUserStatus = (currentValue) => {
  const statusObj = USER_STATUS.find((obj) => obj.name !== currentValue);
  if (statusObj) {
    return statusObj.id;
  }

  return null;
};

export const getAddButtonObj = ({ heading }) => {
  return [
    {
      label: heading,
      key: TABLE_ACTION_KEYS.ADD,
      icon: <HiOutlinePlusCircle />,
    },
  ];
};

export const getLabelFromObject = (array, value) => {
  let obj = array.find((obj, i, arr) => obj?.value === value);
  if (obj === undefined) {
    return "NA";
  } else {
    return obj.label;
  }
};

export const getFirstDayOfCurrMonth = () => {
  const currentDate = new Date();
  return new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);
};

export const getLastDayOfCurrMonth = () => {
  const currentDate = new Date();
  return new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0);
};

export const getUserStatus = (value) => {
  return USER_STATUS.find((obj, i) => obj.id === value);
};

export const checkPermissions = (identifier, type) => {
  const { user } = getState().auth || {};
  if (user?.userType === ROLES.SUPER_ADMIN) {
    if (JSON.parse(user?.roles || "[]")?.length) {
      const rolesArray = JSON.parse(user?.roles || "[]");

      const page = rolesArray.find(
        (role) => role.pageIdentifier === identifier
      );

      if (!page) return false;

      if (type === "view") return page.view;
      if (type === "addEdit") return page.addEdit;
    } else return true;
  } else {
    return false;
  }
};

export const formatAmount = (amount) => {
  const nf = new Intl.NumberFormat("en-IN");
  return `₹ ${nf.format(amount)}`;
};

export function numberToWordsIndian(num) {
  if (num === 0) return "zero";

  const ones = [
    "",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "ten",
    "eleven",
    "twelve",
    "thirteen",
    "fourteen",
    "fifteen",
    "sixteen",
    "seventeen",
    "eighteen",
    "nineteen",
  ];

  const tens = [
    "",
    "",
    "twenty",
    "thirty",
    "forty",
    "fifty",
    "sixty",
    "seventy",
    "eighty",
    "ninety",
  ];

  function twoDigits(n) {
    if (n < 20) return ones[n];
    return tens[Math.floor(n / 10)] + (n % 10 ? "-" + ones[n % 10] : "");
  }

  function threeDigits(n) {
    if (n < 100) return twoDigits(n);
    return (
      ones[Math.floor(n / 100)] +
      " hundred" +
      (n % 100 ? " " + twoDigits(n % 100) : "")
    );
  }

  const units = [
    { value: 10000000, str: "crore" },
    { value: 100000, str: "lakh" },
    { value: 1000, str: "thousand" },
    { value: 100, str: "hundred" },
  ];

  let result = "";
  for (const unit of units) {
    const quotient = Math.floor(num / unit.value);
    if (quotient > 0) {
      result +=
        (unit.value === 100
          ? ones[quotient] + " " + unit.str
          : twoDigits(quotient) + " " + unit.str) + " ";
      num %= unit.value;
    }
  }

  if (num > 0) {
    result += (result ? "and " : "") + twoDigits(num);
  }

  return result.charAt(0).toUpperCase() + result.slice(1).trim();
}

export function handleUploadExcelFiles(file, filetype, setLoading, setRefresh) {
  setLoading(true);
  let formDataToSend = new FormData();
  formDataToSend.append("file", file[0]);
  formDataToSend.append("fileType", filetype);

  postApi(APP_API.IMPORT_FILE, formDataToSend)
    .then(({ statusCode, data, message }) => {
      if (statusCode === 200) {
        toast.push(
          <Notification type="success">
            {message}! Wait for few mins to see the changes
          </Notification>
        );
      }
    })
    .catch((error) => {
      toast.push(<Notification type="danger">{error.message}</Notification>);
    })
    .finally(() => {
      setLoading(false);
      setRefresh((prev) => !prev);
    });
}


export const handleDownloadExcel = async ({
  search,
  filterValue,
  fileType,
  setExportLoading,
  unavailableItems,
}) => {
  try {
    setExportLoading(true);
    console.log('unavailableItems', unavailableItems, search, filterValue, fileType)
    const postResponse = await fetch(
      `${appConfig.apiBaseUrl}${APP_API.EXPORT_FILE}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${getState().auth?.session?.token}`,
        },
        body: JSON.stringify({
          fileType,
          ...(search && {
            search,
          }),
          ...(filterValue?.customerGroup?.value && {
            customerGroup: filterValue?.customerGroup?.value,
          }),
          ...(filterValue?.conditionType?.value && {
            conditionType: filterValue?.conditionType?.value,
          }),
          ...(filterValue?.purchaseStatus?.value && {
            isAccepted: filterValue?.purchaseStatus?.value,
          }),
          ...(filterValue?.dateRange?.[0] && {
            startDate: moment(filterValue?.dateRange?.[0]).format("YYYY-MM-DD"),
          }),
          ...(filterValue?.dateRange?.[1] && {
            endDate: moment(filterValue?.dateRange?.[1]).format("YYYY-MM-DD"),
          }),
          ...(filterValue?.material?.value && {
            materialId: filterValue.material.value,
          }),
          ...(filterValue?.retailers?.value && {
            retailerId: filterValue.retailers.value,
          }),

          ...(filterValue?.SLPMembers?.value && {
            slpId: filterValue.SLPMembers.value,
          }),
          ...(filterValue?.orderStatus?.value && {
            orderStats: filterValue.orderStatus.value,
          }),
          ...(filterValue?.retailerInvoiceStatus?.value && {
            orderStats: filterValue?.retailerInvoiceStatus?.value,
          }),
          ...(filterValue?.paymentStatus?.value && {
            paymentStatus: filterValue.paymentStatus.value,
          }),
          ...(unavailableItems && {
            unavailableItems,
          }),
        }),
      }
    );

    if (!postResponse?.ok) {
      const errorData = await postResponse.json();
      toast.push(
        <Notification type="danger">
          {errorData?.message ||
            `HTTP error in POST API! Status: ${postResponse?.status}`}
        </Notification>
      );
      setExportLoading(false);
      return;
    }

    const postData = await postResponse.json();

    if (postData?.statusCode !== 200) {
      toast.push(
        <Notification type="danger">
          {postData?.message ||
            "An error occurred while processing your request."}
        </Notification>
      );
      setExportLoading(false);
      return;
    }

    const filePath = postData?.data?.path;
    if (!filePath) {
      toast.push(
        <Notification type="danger">
          Failed to get the file path from POST API response.
        </Notification>
      );
      return;
    }

    const getResponse = await fetch(`${appConfig.apiBaseUrl}/${filePath}`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${getState().auth?.session?.token}`,
      },
    });

    if (!getResponse.ok) {
      toast.push(
        <Notification type="danger">
          {`Unable to download the Excel file: ${getResponse.statusText}`}
        </Notification>
      );
      return;
    }

    const blob = await getResponse.blob();

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = postData?.data?.name || "downloaded_excel_file.xlsx";

    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);

    toast.push(
      <Notification type="success">
        Excel file downloaded successfully!
      </Notification>
    );
  } catch (error) {
    toast.push(
      <Notification type="danger">
        Failed to download the Excel file: {error.message}
      </Notification>
    );
  } finally {
    setExportLoading(false);
  }
};

export const getActualDateAndTime = (data) => {
  if (data) {
    const date = new Date(data);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = String(date.getMinutes()).padStart(2, "0");

    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12 || 12;
    hours = String(hours).padStart(2, "0");

    return `${day}/${month}/${year} ${hours}:${minutes} ${ampm}`;
  } else {
    return null;
  }
};

export const DefaultCurrencyFormatter = (value) => {
  if (value >= 1e12) {
    return (value / 1e12).toFixed(2) + "T";
  } else if (value >= 1e9) {
    return (value / 1e9).toFixed(2) + "B";
  } else if (value >= 1e6) {
    return (value / 1e6).toFixed(2) + "M";
  } else if (value >= 1e5) {
    return (value / 1e5).toFixed(2) + "L";
  } else if (value >= 1e3) {
    return (value / 1e3).toFixed(2) + "K";
  }
  return value?.toString();
};

export const IndianCurrencyFormatter = (value) => {
  if (value >= 1e7) {
    return (value / 1e7).toFixed(2) + " Cr";
  } else if (value >= 1e5) {
    return (value / 1e5).toFixed(2) + " L";
  } else if (value >= 1e3) {
    return (value / 1e3).toFixed(2) + " K";
  }
  return value?.toFixed(2);
};

export function getSum(numbers) {
  let sum = 0;
  for (let i = 0; i < numbers?.length; i++) {
    sum += numbers[i];
  }

  return sum;
}

export const isLoggedInColumn = (isLoggedIn) =>
  isLoggedIn ? (
    <FaCheckCircle className="text-green-500" />
  ) : (
    <FaTimesCircle className="text-red-500" />
  );
